import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 23 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 22\" id=\"home\">\n  <path fill-rule=\"evenodd\" d=\"M164.725,358.99h-5.786a0.707,0.707,0,0,1-.708-0.7v-7.537h-3.466v7.537a0.707,0.707,0,0,1-.708.7h-5.786a1.452,1.452,0,0,1-1.445-1.456V348.9a1.514,1.514,0,0,1-1.393-.471,1.924,1.924,0,0,1,.22-2.676l9.6-8.29a1.863,1.863,0,0,1,2.334-.094,0.671,0.671,0,0,1,.147.094l9.6,8.29a1.925,1.925,0,0,1,.22,2.676,1.526,1.526,0,0,1-1.393.472v8.634A1.452,1.452,0,0,1,164.725,358.99Zm-5.077-1.411h5.077l0.028-9.593a0.709,0.709,0,0,1,.994-0.646,1.544,1.544,0,0,0,.774.149,0.534,0.534,0,0,0-.1-0.67l-9.5-8.2a0.716,0.716,0,0,1-.135-0.092,0.455,0.455,0,0,0-.6,0l-9.6,8.29a0.517,0.517,0,0,0-.056.71,3,3,0,0,0,.725-0.189,0.713,0.713,0,0,1,.672.055,0.706,0.706,0,0,1,.322.591v9.548l5.105,0.039v-7.531a0.708,0.708,0,0,1,.709-0.706h4.882a0.708,0.708,0,0,1,.709.706v7.537Z\" transform=\"translate(-145 -337)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/home.svg
// module id = null
// module chunks = 